<template>
  <b-container v-if="verified">
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            OCR KTP 2
          </h1>
        </CCol>
      </CRow>
      <CRow>
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
          </h4>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <div class="col-12">
            <label class="textarea-input">Input Image:</label>
            <input ref="fileupload" class="mb-2 sm-input" type="file" accept="image/png, image/jpeg" @change="onChooseImage">
            <!-- <label v-if="showPreview" class="textarea-input">Preview Image:</label>
            <b-img v-if="showPreview" :src="imagePreview" class="preview-image mb-2"></b-img> -->
<!--             <textarea id="input-service-id"
              class="sm-input"
              placeholder="Masukkan teks yang akan di analisa di sini..."
              v-model="inputText"
              rows="3"
            ></textarea> -->
          </div>
          <CCol col="12" class="form-button">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit" class="btn">
                  <span><img src=""></span>Submit
                </router-link>
              </div>
            </div>
          </CCol>
          <div class="col-12 mb-5">
            <label v-if="showPreview" class="textarea-input">Preview Image:</label>
            <canvas v-show="showPreview && currCanvas == 'preview'" id="cvs-preview" class="preview-annotate mb2"></canvas>
            <canvas v-show="showPreview && currCanvas == 'annotate'" id="cvs-annotate" class="preview-annotate mb2"></canvas>
            <!-- <b-img v-if="showPreview" :src="imagePreview" class="preview-canvas mb-2"></b-img> -->
          </div>
        </CRow>
        <!-- <CRow>
          <div class="col-12">
            <label class="sm-input" for="input-customer-id">Customer ID</label>
            <input id="input-customer-id"
              disabled
              class="sm-input"
              :maxlength="50"
              v-model="customerId"
            >
          </div>
        </CRow>
        <CRow>
          <CCol col="12" class="item-footer mt-4">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickBack" class="btn custom leftside">
                  <span><img src=""></span>Kembali
                </router-link>
                <router-link :to="{}" @click.native="onClickSubmit" class="btn custom fif-blue-1 rightside">
                  <span><img src=""></span>Submit
                </router-link>
              </div>
            </div>
          </CCol>
        </CRow> -->
      </div>
      <CRow v-if="keywords.length > 0">
        <CCol xm="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            RESPONSE DATA
          </h4>
        </CCol>
      </CRow>
      <div v-if="keywords.length > 0" class="content">
        <CRow>
          <div class="col-12">
            <b-table small
              :fields="fields"
              :items="keywords"
            >
              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>
            </b-table>
          </div>
        </CRow>
      </div>
      <!-- <Modal v-if="showOfficeModal" :isList="true" :closeButton="false">
        <div slot="header">
          <label>Pilih Office</label>
        </div>
        <div slot="body">
          <div class="grid-kontrak list-kontrak">
            <div v-for="(office, index) in officeOptions"
              :key="'list-office-' + index"
              class="grid-item"
              role="navigation"
              @click="onClickOffice(office)"
            >
              <div class="item-header sm">
                <img src="../../assets/images/file.svg"> {{office.name}}
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-footer">
            <button class="btn-submit white" @click="showOfficeModal = false">
              Batal
            </button>
          </div>
        </div>
      </Modal>
      <Modal v-if="showDaytimeModal" :isList="true" :closeButton="false">
        <div slot="header">
          <label>Pilih Tanggal Booking</label>
        </div>
        <div slot="body">
          <div class="grid-kontrak list-kontrak">
            <div v-for="(daytime, index) in daytimeOptions"
              :key="'list-daytime-' + index"
              class="grid-item"
              role="navigation"
              @click="onClickDaytime(daytime)"
            >
              <div class="item-header sm">
                <img src="../../assets/images/file.svg"> {{daytime.dateDisplay}}
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-footer">
            <button class="btn-submit white" @click="showDaytimeModal = false">
              Batal
            </button>
          </div>
        </div>
      </Modal>
      <Modal v-if="showClocktimeModal" :isList="true" :closeButton="false">
        <div slot="header">
          <label>Pilih Jam Booking</label>
        </div>
        <div slot="body">
          <div class="grid-kontrak list-kontrak">
            <div v-for="(clocktime, index) in clocktimeOptions"
              :key="'list-clocktime-' + index"
              class="grid-item"
              role="navigation"
              @click="onClickClocktime(clocktime)"
            >
              <div class="item-header sm">
                <img src="../../assets/images/file.svg"> {{clocktime.startTime + ' - ' + clocktime.endTime}}
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-footer">
            <button class="btn-submit white" @click="showClocktimeModal = false">
              Batal
            </button>
          </div>
        </div>
      </Modal> -->
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
            <!-- <button v-if="errorReload" class="btn-submit white" @click="onClickBack">
              Kembali
            </button>
            <button v-else class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
            <button v-if="errorReload" class="btn-submit" @click="onClickReload">
              Muat Ulang
            </button>
            <button v-else class="btn-submit" @click="onClickBack">
              Kembali
            </button>
            <button v-else class="btn-submit" @click="onClickMenu">
              Menu Utama
            </button> -->
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
// import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      verified: false,
      isLoading: false,
      showErrorModal: false,
      // showOfficeModal: false,
      // showDaytimeModal: false,
      // showClocktimeModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      inputText: "",
      fields: [
          { key: 'label', label: 'Label' },
          { key: 'value', label: 'Value' },
          { key: 'confidence', label: 'Confidence' },
      ],
      keywords: [],
      boxes: [],
      categoryMap: [],
      imagePreview: null,
      showPreview: false,
      currCanvas: 'preview',
      file: null,
      // serviceId: "",
      // serviceName: "",
      // customerId: "",
      // contractNo: "",
      // servOfficeCode: "",
      // workDayBook: 1,
      // officeOptions: [],
      // daytimeOptions: [],
      // clocktimeOptions: [],
      // selectedOffice: {},
      // selectedDaytime: {},
      // selectedClocktime: {}
    }
  },
  methods: {
    onChooseImage(e){
      this.keywords = []
      const file = e.target.files[0]
      if(file){
        this.file = e.target.files[0]
        this.imagePreview = URL.createObjectURL(file)
        this.createBase64Image(file)
        // this.imagePreview = URL.createObjectURL(file)
        const cvs = document.getElementById('cvs-preview')
        const ctx = cvs.getContext('2d')
        const cvs2 = document.getElementById('cvs-annotate')
        const ctx2 = cvs2.getContext('2d')
        ctx.clearRect(0, 0, cvs.width, cvs.height)
        ctx2.clearRect(0, 0, cvs.width, cvs.height)
        const img = new Image
        img.src = URL.createObjectURL(e.target.files[0])
        img.onload = function() {
          cvs.width = img.width
          cvs.height = img.height
          ctx.drawImage(img, 0, 0)
          cvs2.width = img.width
          cvs2.height = img.height
          ctx2.drawImage(img, 0, 0)
        }
        // this.createBase64Image(file)
        this.currCanvas = 'preview'
        this.showPreview = true
      }
    },
    createBase64Image(FileObject) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.base64 = reader.result.split(",")[1];
      }
      reader.readAsDataURL(FileObject);
    },
    // async getOffices(){
    //   this.isLoading = true
    //   let processUrl = "/office/get-office-iss-enabled?exist=1"
    //   await this.$axios.get(processUrl).then((response) => {
    //     if (response.status === 200){
    //       this.officeOptions = response.data
    //       this.selectedOffice = {}
    //     }
    //     else {
    //       this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //       this.errorReload = true
    //       this.showErrorModal = true
    //     }
    //   })
    //   .catch(_ => {
    //     this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //     this.errorReload = true
    //     this.showErrorModal = true
    //   })
    //   .finally(() => {
    //     this.isLoading = false
    //   })
    // },
    // onFocusOffice(){
    //   this.showOfficeModal = true
    // },
    // onFocusDaytime(){
    //   this.showDaytimeModal = true
    // },
    // onFocusClocktime(){
    //   this.showClocktimeModal = true
    // },
    // onClickOffice(office){
    //   this.selectedOffice = office
    //   this.isLoading = true
    //   let processUrl = "/fmc/getDayTimeFrame"
    //   processUrl += "?servOfficeCode=" + this.selectedOffice.servOfficeCode
    //   processUrl += "&bookingDate=" + moment().add(this.workDayBook, 'day').format("YYYY-MM-DD")
    //   processUrl += "&serviceId=" + this.serviceId
    //   this.$axios.get(processUrl).then((response) => {
    //     if (response.status === 200){
    //       this.daytimeOptions = response.data.data.filter(item => item.available)
    //       this.daytimeOptions = this.daytimeOptions.map(item => {
    //         let split = item.date.split("-")
    //         let newDate = split[2] + "-" + split[1] + "-" + split[0]
    //         item.dateDisplay = moment(newDate).locale("id").format("dddd, D MMMM YYYY")
    //         return item
    //       })
    //       this.selectedDaytime = {}
    //       this.showOfficeModal = false
    //     }
    //     else {
    //       this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //       this.errorReload = true
    //       this.showErrorModal = true
    //     }
    //   })
    //   .catch(_ => {
    //     this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //     this.errorReload = true
    //     this.showErrorModal = true
    //   })
    //   .finally(() => {
    //     this.isLoading = false
    //   })
    // },
    // onClickDaytime(daytime){
    //   this.selectedDaytime = daytime
    //   let dateSplit = this.selectedDaytime.date.split("-")
    //   this.selectedDaytime.dateFlip = dateSplit[2] + '-' + dateSplit[1] + '-' + dateSplit[0]
    //   this.isLoading = true
    //   let processUrl = "/fmc/getClockTimeFrame"
    //   processUrl += "?servOfficeCode=" + this.selectedOffice.servOfficeCode
    //   processUrl += "&bookingDate=" + this.selectedDaytime.dateFlip
    //   processUrl += "&serviceId=" + this.serviceId
    //   this.$axios.get(processUrl).then((response) => {
    //     if (response.status === 200){
    //       this.clocktimeOptions = response.data.data.timeFrame.filter(item => item.slot > 0)
    //       this.selectedClocktime = {}
    //       this.showDaytimeModal = false
    //     }
    //     else {
    //       this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //       this.errorReload = false
    //       this.showErrorModal = true
    //     }
    //   })
    //   .catch(_ => {
    //     this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
    //     this.errorReload = false
    //     this.showErrorModal = true
    //   })
    //   .finally(() => {
    //     this.isLoading = false
    //   })
    // },
    // onClickClocktime(clocktime){
    //   this.selectedClocktime = clocktime
    //   this.selectedClocktime.display = clocktime.startTime + ' - ' + clocktime.endTime
    //   this.showClocktimeModal = false
    // },
    // onClickBack(){
    //   this.$store.commit('set', ['contractNo', ""])
    //   this.$store.commit('set', ['servOfficeCode', ""])
    //   this.$store.commit('set', ['workDayBook', ""])
    //   // this.$router.push({ name: "Kontrak" })
    //   this.$router.push({ name: "KontrakBypass" })
    // },
    // onClickMenu(){
    //   this.$store.commit('set', ['serviceId', ""])
    //   this.$store.commit('set', ['serviceName', ""])
    //   this.$store.commit('set', ['customerId', ""])
    //   this.$store.commit('set', ['contractList', ""])
    //   this.$store.commit('set', ['contractNo', ""])
    //   this.$store.commit('set', ['servOfficeCode', ""])
    //   this.$store.commit('set', ['workDayBook', ""])
    //   this.$router.push({ name: "Menu" })
    // },
    // async onClickReload(){
    //   await this.getOffices()
    //   for(let i = 0; i < this.officeOptions.length; i++){
    //     if(this.officeOptions[i].servOfficeCode == this.servOfficeCode){
    //       this.selectedOffice = this.officeOptions[i]
    //       this.onClickOffice(this.officeOptions[i])
    //       break
    //     }
    //   }
    // },
    drawAnnotateBox() {
      const cvs = document.getElementById("cvs-annotate")
      const ctx = cvs.getContext("2d")
      ctx.strokeStyle = "red"
      ctx.lineWidth = parseInt(cvs.width/500) + 1
      ctx.beginPath()
      for(let box of this.boxes){
        ctx.beginPath()
        ctx.moveTo(box.coordinate[0][0], box.coordinate[0][1])
        ctx.lineTo(box.coordinate[1][0], box.coordinate[1][1])
        ctx.lineTo(box.coordinate[2][0], box.coordinate[2][1])
        ctx.lineTo(box.coordinate[3][0], box.coordinate[3][1])
        ctx.closePath()
        ctx.stroke()
      }
    },
    onClickSubmit(){
      this.isLoading = true
      // let processUrl = "https://core.ktp.inergi.id/document_classifier"
      let processUrl = "https://validation.demo.inergi.id/api/core-ktp/document_classifier"
      let data = {
        "image": this.base64,
        "key": "d88a5b1144137cd939a0cc6d43b75dfd",
        "return_segmented": false,
        "return_person_photo": false,
        "return_signature_photo": false,
        "classification": false
      }
      // let data = new FormData()
      // data.set('officeCode', this.selectedOffice.officeCode)
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){

          if(response.data.type != "ktp"){
            this.errorLabel = "Dokumen tidak dideteksi sebagai e-KTP"
            this.errorReload = false
            this.showErrorModal = true
            return
          }

          let raw = response.data.data
          let entries = []
          for (const [key, value] of Object.entries(raw)){
            entries.push({label: key, value: value.value, confidence: value.confidence})
          }
          this.keywords = entries
          // this.boxes = response.data.data_raw
          // this.drawAnnotateBox()
          // this.currCanvas = 'annotate'
          // let entries = []
          // let isNewWord = false
          // let currCategory = ""
          // let currCount = 0
          // let currWord = ""
          // let currTotalScore = 0
          // for(let i = 0; i < raw.length; i++){
          //   let [prefix, category] = raw[i].entity.split("-")
          //   // if B-prefix, start new word
          //   if(prefix === "B"){
          //     isNewWord = true
          //   }
          //   else{
          //     // if I-prefix, but differing category, start new word
          //     if(currCategory !== "" && category !== currCategory){
          //       isNewWord = true
          //     }
          //     // if I-prefix and same category, continue previous word
          //     else{
          //       isNewWord = false
          //     }
          //   }
          //   // if new word and there is a previous word, push and reset tally
          //   if(isNewWord && currCount > 0){
          //     currWord = currWord.replace(/▁/g," ").trim()
          //     entries.push({ word:currWord, category:this.categoryMap[currCategory], score:parseFloat(currTotalScore / currCount) })
          //     currCategory = ""
          //     currCount = 0
          //     currWord = ""
          //     currTotalScore = 0
          //   }
          //   // start tally
          //   currCategory = category
          //   currCount += 1
          //   currWord += raw[i].word
          //   currTotalScore += parseFloat(raw[i].score)
          // }
          // // push the last keyword
          // currWord = currWord.replace(/▁/g," ").trim()
          // entries.push({ word:currWord, category:this.categoryMap[currCategory], score:parseFloat(currTotalScore / currCount) })
          // this.keywords = entries
        }
        else {
          this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.errorReload = false
          this.showErrorModal = true
          return
        }
      })
      .catch(error => {
        // if(error.response) this.errorLabel = error.response.data.reason
        if(error.response){
          if(error.response.status == "401"){
            this.errorLabel = "API Key tidak valid atau sudah tidak berlaku. Mohon menghubungi tim untuk kode akses baru."
            this.$cookies.remove("api-key-ktp2")
            delete this.$axios.defaults.headers.post['API-Key']
          }
          else{
            if(error.response.data && error.response.data.reason) this.errorLabel = error.response.data.reason
            else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          }
        }
        else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.errorReload = false
        this.showErrorModal = true
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  },
  async mounted() {
    let res = ""
    if(this.$cookies.get("api-key-ktp2")){
      res = this.$cookies.get("api-key-ktp2")
      this.$axios.defaults.headers.post['API-Key'] = res
      this.$axios.defaults.headers.get['API-Key'] = res
      this.verified = true
    }
    else{
      while(!res) res = window.prompt("Please enter your access key.", "")
      while(!this.verified){
        // await this.$axios.post("http://10.10.131.108:9000/auth/validate-key", null, { headers: {"API-Key": res} }).then(_ => {
        await this.$axios.post("https://validation.demo.inergi.id/api/auth/validate-key", null, { headers: {"API-Key": res} }).then(_ => {
          this.$cookies.set("api-key-ktp2", res)
          this.$axios.defaults.headers.post['API-Key'] = res
          this.$axios.defaults.headers.get['API-Key'] = res
          this.verified = true
        })
        .catch(error => {
          if(error.response){
            if(error.response.status == "401"){
              res = ""
              while(!res) res = window.prompt("Key validation failed. Please enter your access key.", "")
            }
            else{
              res = ""
              while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
            }
          }
          else{
            res = ""
            while(!res) res = window.prompt("Network error during verification. Please enter your access key.", "")
          }
        })
      }
    }
  },
}
</script>